import { render } from "./LoginPage.vue?vue&type=template&id=16d8eba4&scoped=true&ts=true"
import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=16d8eba4&lang=scss&scoped=true"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d8eba4"],['__file',"src/pages/LoginPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16d8eba4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16d8eba4', __exports__)) {
    api.reload('16d8eba4', __exports__)
  }
  
  module.hot.accept("./LoginPage.vue?vue&type=template&id=16d8eba4&scoped=true&ts=true", () => {
    api.rerender('16d8eba4', render)
  })

}


export default __exports__